/** @param {string} str */
export default function isFFUrl(str) {
  return str.includes('farmersfridge.com');
}
